<template>
  <div>
    <!-- Input Gram -->
    <div
      v-if="
        (orderType == 'market' && inputType == 'gram') ||
        direction == 'sell' ||
        orderType == 'limit'
      "
      :class="isShowInputPrice ? 'mb-5' : ''"
    >
      <div class="font-semibold mb-3">
        {{ direction == "sell" ? "Sell" : "Buy in Gram" }}
      </div>

      <div class="flex items-center gap-2 text-2xl">
        <div class="mr-4">g</div>

        <div class="grow flex">
          <InputPriceComp
            v-model="inputGram"
            class_prop="w-full input bg-transparent text-right text-2xl px-0"
            :maxDecimals="maxDecimalsGram"
            @focusBro="setFocusInputGram(true)"
            @blurBro="setFocusInputGram(false)"
            @done="calculatePrice"
          />

          <div class="text-4xl text-grey-13 text-right font-extralight">|</div>
        </div>

        <div class="cursor-pointer ml-4" @click="decreaseInputGram()">
          <IconCircleMinus />
        </div>

        <div class="cursor-pointer" @click="increaseInputGram()">
          <IconCirclePlus />
        </div>
      </div>

      <div v-if="errorMessageInputGram" class="text-danger text-2xs mt-5">
        {{ errorMessageInputGram }}
      </div>

      <GramSuggestions
        v-if="direction == 'buy'"
        class="mt-5 mb-1"
        :contractId="contractId"
        @useGram="setInputGram"
      />
    </div>

    <!-- Input Price -->
    <div v-if="isShowInputPrice">
      <div class="font-semibold mb-3">
        {{
          orderType == "market"
            ? `Buy in ${currency == "idr" ? "Rupiah" : "Dollar"}`
            : "Set Price per Gram"
        }}
      </div>

      <div class="flex items-center gap-2 text-2xl mb-5">
        <div class="mr-4">
          {{ currency == "idr" && orderType == "market" ? "*Rp" : "*$" }}
        </div>

        <div class="grow flex">
          <InputPriceComp
            v-model="inputPrice"
            class_prop="w-full input bg-transparent text-right text-2xl px-0"
            :maxDecimals="maxDecimalsPrice"
            @focusBro="setFocusInputPrice(true)"
            @blurBro="setFocusInputPrice(false)"
            @done="calculateGram"
          />

          <div class="text-4xl text-grey-13 text-right font-extralight">|</div>
        </div>
      </div>

      <div v-if="errorMessageInputPrice" class="text-danger text-2xs mb-5">
        {{ errorMessageInputPrice }}
      </div>

      <PriceSuggestions
        v-if="inputType == 'price' && orderType == 'market'"
        class="mb-5"
        :contractId="contractId"
        :direction="direction"
        :orderType="orderType"
        @usePrice="setInputPrice"
      />

      <div v-if="orderType == 'market'" class="text-grey text-2xs">
        *The amount will be rounded down based on the selected contract multiple
        & used as the Total Payment (incl. Fees, Tax, & FX buffer)
      </div>
      <div v-else class="text-grey text-2xs">
        *Set your desired price per gram, within ±10% of the market price.
        Pricing is in USD as it follows the international gold market
      </div>
    </div>

    <div
      v-if="orderType == 'market' && direction == 'buy'"
      class="relative py-5"
    >
      <hr class="border border-grey-13 my-0 m--5" />
      <div class="absolute flex justify-center items-center top-1/5 w-full">
        <IconSwapVerticalCircle
          class="cursor-pointer"
          width_prop="1.5rem"
          height_prop="1.5rem"
          @click.native="swapInput()"
        />
      </div>
    </div>

    <div v-if="orderType == 'market' && direction == 'buy'">
      <div class="text-grey font-semibold mb-3">Equal To</div>

      <div class="flex justify-between items-center text-grey text-2xl">
        <div class="mr-5">
          {{ inputType == "price" ? "g" : currency == "idr" ? "Rp" : "$" }}
        </div>
        <div>
          {{ inputType == "price" ? totalGramShown : totalPriceShown }}
        </div>
      </div>

      <div
        v-if="errorMessageInputPrice && inputType == 'price'"
        class="text-danger text-2xs"
      >
        {{ errorMessageInputPrice }}
      </div>
    </div>
  </div>
</template>

<script>
  import { Decimal } from "decimal.js"
  import tradingFormula, { configs } from "@bei/trading-formula"

  import utils from "../../../utils"

  import IconSwapVerticalCircle from "../../icons/IconSwapVerticalCircle.vue"
  import InputPriceComp from "../../InputPrice.vue"
  import PriceSuggestions from "./PriceSuggestions.vue"
  import GramSuggestions from "./GramSuggestions.vue"
  import IconCircleMinus from "../../icons/IconCircleMinus.vue"
  import IconCirclePlus from "../../icons/IconCirclePlus.vue"

  export default {
    name: "InputOrder",

    components: {
      IconSwapVerticalCircle,
      InputPriceComp,
      PriceSuggestions,
      GramSuggestions,
      IconCircleMinus,
      IconCirclePlus,
    },

    props: {
      contractId: [Number, String],
      direction: String,
      orderType: String,
      totalTypeAIdr: String,
      totalTypeAUsd: String,
      finalAmountIdr: [Number, String],
      finalAmountUsd: [Number, String],
      limitPrice: [Number, String],
    },

    data() {
      return {
        /** @type {"price" | "gram"} */
        inputType: "price",

        /** Final amount */
        inputPriceMarket: 0,
        /** Price per gram */
        inputPriceLimit: 0,

        inputPrice: 0,
        oldInputPrice: 0,
        totalGram: 0,
        isFocusInputPrice: false,
        errorMessageInputPrice: "",

        inputGramSell: 0,
        inputGramBuy: 0,
        oldInputGram: 0,
        isFocusInputGram: false,
        totalPrice: 0,
        errorMessageInputGram: "",

        preventReview: false,
      }
    },

    computed: {
      isShowInputPrice() {
        if (
          (this.inputType == "price" && this.direction == "buy") ||
          this.orderType == "limit"
        ) {
          return true
        } else {
          return false
        }
      },

      currency() {
        return this.$store.state.currency
      },

      contractConfigs() {
        return this.$store.getters.getContractConfigs(this.contractId)
      },

      streamingRateByDirection() {
        return this.$store.getters.streamingRateByDirection(this.direction)
      },

      maxDecimalsPrice() {
        if (this.orderType == "limit") {
          return configs.fractionDigit.usd
        } else {
          if (this.currency == "idr") {
            return configs.fractionDigit.idr
          } else {
            return configs.fractionDigit.usd
          }
        }
      },

      maxDecimalsGram() {
        const decimalPoints = new Decimal(
          this.contractConfigs.weightInGram,
        ).decimalPlaces()
        return decimalPoints
      },

      orderTypeComputed() {
        return this.orderType
      },

      inputGram: {
        get() {
          return this.direction == "sell"
            ? this.inputGramSell
            : this.inputGramBuy
        },

        set(newValue) {
          if (this.direction == "sell") {
            this.inputGramSell = newValue
          } else {
            this.inputGramBuy = newValue
          }
        },
      },

      totalGramShown() {
        return utils.currencyFormat(this.totalGram)
      },

      totalPriceShown() {
        return utils.currencyFormat(this.totalPrice)
      },
    },

    watch: {
      currency(newValue) {
        if (newValue == "idr" && this.orderType == "market") {
          this.setInputPriceSilently(this.totalTypeAIdr)
        } else if (newValue == "usd" && this.orderType == "market") {
          this.setInputPriceSilently(this.totalTypeAUsd)
        }
      },

      contractId() {
        if (this.orderType == "limit") {
          const intervalTemp = setInterval(() => {
            this.setInputPriceSilently(new Decimal(this.priceGram).toNumber())
            clearInterval(intervalTemp)
          }, 100)
        }
      },

      direction(newValue) {
        this.inputGramValidation()
        this.inputPriceValidation()

        if (newValue == "sell") {
          this.totalGram = this.inputGramSell
        } else {
          this.totalGram = this.inputGramBuy
        }

        this.$emit("totalGramUpdated", this.totalGram)
      },

      orderType() {
        this.initializeInputPrice()
      },

      totalTypeAUsd(newValue) {
        if (this.currency == "usd" && this.orderType == "market") {
          this.setInputPriceSilently(newValue)
        }
      },
      totalTypeAIdr(newValue) {
        if (this.currency == "idr" && this.orderType == "market") {
          this.setInputPriceSilently(newValue)
        }
      },

      inputGram() {
        this.inputGramValidation()
      },

      inputPrice() {
        this.inputPriceValidation()
      },

      preventReview() {
        this.$emit("update:preventReview", this.preventReview)
      },
    },

    mounted() {
      this.initializeInputPrice()
    },

    methods: {
      swapInput() {
        this.inputType = this.inputType == "price" ? "gram" : "price"
      },

      calculateGram(price) {
        if (this.orderType == "limit") {
          this.$emit("limitPriceUpdated", price)
          return
        }

        const gold = this.$store.state.golds[this.contractId]

        if (!gold) return

        let pricePerGram =
          this.direction == "sell"
            ? gold.pricePerGramSell
            : gold.pricePerGramBuy
        if (this.currency == "idr") {
          pricePerGram = Decimal.mul(
            pricePerGram,
            this.streamingRateByDirection,
          ).toNumber()
        }

        const gram = tradingFormula.tradeTicket.calculateGramFromTotalTypeA({
          pricePerGram: pricePerGram,
          totalTypeB: price,
          direction: this.direction,
          orderType: this.orderType,
        })

        const decimalPoint = new Decimal(
          this.contractConfigs.weightInGram,
        ).decimalPlaces()

        const oldTotalGram = this.totalGram

        this.totalGram = new Decimal(gram).toFixed(
          decimalPoint,
          Decimal.ROUND_DOWN,
        )

        if (oldTotalGram == this.totalGram) {
          this.setInputPriceSilently(this.oldInputPrice)
          return
        }

        this.oldInputPrice = this.inputPrice
        this.totalPrice = this.inputPrice
        this.inputGram = this.totalGram
        this.$emit("totalGramUpdated", this.totalGram)
      },

      // change inputPrice and trigger calculateGram
      setInputPrice(newValue) {
        // if user editing inputPrice, then do not change inputPrice
        if (this.isFocusInputPrice) return

        this.inputPrice = newValue
        this.calculateGram(newValue)
      },

      // change inputPrice without triggering calculateGram
      setInputPriceSilently(newValue) {
        // if user editing inputPrice, then do not change inputPrice
        if (this.isFocusInputPrice) return

        this.inputPrice = newValue
        this.oldInputPrice = newValue
        this.totalPrice = newValue
      },

      setFocusInputPrice(val) {
        this.isFocusInputPrice = val
      },

      calculatePrice(gram) {
        this.totalGram = gram

        this.$emit("totalGramUpdated", gram)
      },

      setInputGram(newValue) {
        this.inputGram = newValue
        this.calculatePrice(newValue)
      },

      setInputGramSilently(newValue) {
        this.inputGram = newValue
        this.oldInputGram = this.inputGram
      },

      setFocusInputGram(val) {
        this.isFocusInputGram = val
      },

      decreaseInputGram() {
        const decremental = this.contractConfigs.weightInGram
        this.setInputGram(Decimal.sub(this.inputGram, decremental).toNumber())
      },

      increaseInputGram() {
        const incremental = this.contractConfigs.weightInGram
        this.setInputGram(Decimal.add(this.inputGram, incremental).toNumber())
      },

      inputGramValidation() {
        // check if available gold balance is enough
        const AvailableGoldBalance = this.$store.getters[
          "goldBalanceNew/getAvailableTradeGoldByContractId"
        ](this.contractId)
        if (
          this.direction == "sell" &&
          new Decimal(this.inputGram).greaterThan(AvailableGoldBalance)
        ) {
          this.errorMessageInputGram = "Amount exceeds your holdings"
          this.preventReview = true

          return
        }

        this.errorMessageInputGram = ""
        // cannot set true unless another error still exist. For example error in inputPrice
        if (this.errorMessageInputPrice == "") {
          this.preventReview = false
        }
      },

      inputPriceValidation() {
        const gold = this.$store.getters.getGoldByContractId(this.contractId)

        const pricePerGramMarket = new Decimal(
          this.direction == "sell"
            ? gold.pricePerGramSell
            : gold.pricePerGramBuy,
        )
        // Check limit price away
        if (this.orderType == "limit") {
          const limitPrice = new Decimal(this.inputPrice)

          let minMaxLimitPrice
          if (this.contractConfigs.contractType == "kau") {
            minMaxLimitPrice = this.$store.state.minMaxLimitPriceKAU
          } else {
            minMaxLimitPrice = this.$store.state.minMaxLimitPriceIGX
          }

          if (
            limitPrice.lessThanOrEqualTo(
              pricePerGramMarket.minus(
                pricePerGramMarket.times(minMaxLimitPrice),
              ),
            ) ||
            limitPrice.greaterThanOrEqualTo(
              pricePerGramMarket.plus(
                pricePerGramMarket.times(minMaxLimitPrice),
              ),
            )
          ) {
            this.errorMessageInputPrice = `Price limit is max ${utils.currencyFormat(
              Decimal.mul(minMaxLimitPrice, 100).toFixed(2),
            )}% from the current price`

            // if contract is kau, prevent user to continue to review order
            if (this.contractConfigs.contractType == "kau") {
              this.preventReview = true
            }

            return
          }
        }

        // check if balance USD is enough
        const availableTradeBalanceUsd = new Decimal(
          this.$store.state.availableTradeBalanceUsd,
        )
        if (
          this.orderType == "market" &&
          availableTradeBalanceUsd.lessThan(this.finalAmountUsd) &&
          this.direction == "buy"
        ) {
          if (
            this.$store.getters.paymentMethod == "gopay" &&
            !this.$store.getters.isGopayLinked
          ) {
            // if gopay, check if gopay is linked. If not, then continue order
          } else {
            this.errorMessageInputPrice = "Your RPED balance is insufficient"
            this.preventReview = true

            return
          }
        }

        // check if balance IDR is enough
        const availableTradeBalanceIdr = new Decimal(
          this.$store.state.availableTradeBalanceIdr,
        )
        if (
          this.orderType == "market" &&
          availableTradeBalanceIdr.lessThan(this.finalAmountIdr) &&
          this.direction == "buy"
        ) {
          if (
            this.$store.getters.paymentMethod == "gopay" &&
            !this.$store.getters.isGopayLinked
          ) {
            // if gopay, check if gopay is linked. If not, then continue order
          } else {
            this.errorMessageInputPrice = "Your RPED balance is insufficient"
            this.preventReview = true

            return
          }
        }

        this.errorMessageInputPrice = ""
        // cannot set true unless another error still exist. For example error in inputGram
        if (this.errorMessageInputGram == "") {
          this.preventReview = false
        }
      },

      initializeInputPrice() {
        if (this.orderType == "market") {
          const tempPrice =
            this.currency == "idr" ? this.totalTypeAIdr : this.totalTypeAUsd
          this.setInputPriceSilently(tempPrice)
        } else {
          this.setInputPriceSilently(new Decimal(this.limitPrice).toNumber())
        }
      },
    },
  }
</script>
